/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

// Modules
import account from './modules/account';
import alert from './modules/alert';
import auth from './modules/auth';
import category from './modules/category';
import careplan from './modules/careplan';
import patientList from './modules/patientList';
import patient from './modules/patient';
import progress from './modules/progress';
import profile from './modules/profile';
import user from './modules/user';
import resolve from './modules/resolve';
import delegate from './modules/delegate';
import message from './modules/message';
import reminders from './modules/reminders';
import assessments from './modules/assessments';
import organisation from './modules/organisation';
import group from './modules/group';
import followUps from './modules/followUps';
import managementProtocolTemplate from './modules/managentProtocolTemplate';
import reports from './modules/reports'

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    account,
    auth,
    careplan,
    category,
    patientList,
    progress,
    profile,
    patient,
    user,
    alert,
    resolve,
    delegate,
    message,
    reminders,
    assessments,
    organisation,
    group,
    followUps,
    managementProtocolTemplate,
    reports
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins: debug ? [createLogger()] : []
});
